"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    title: "Uh oh, something went wrong...",
};
